/** @format */

import { memo } from 'react'

import styles from 'dir/styles/courses.module.css'

export const _10 = memo(() => (
  <section className={styles.section}>
    <h2 className={styles.h2}>10 - Дополнительные материалы</h2>
    <ul className={styles.list}>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://redux.js.org/" target="_blank">
          Документация Redux
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://rajdee.gitbooks.io/redux-in-russian/content/" target="_blank">
          Документация Redux на русском
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://jaysoo.ca/2016/02/28/organizing-redux-application/" target="_blank">
          Three Rules For Structuring (Redux) Applications
        </a>
      </li>
      <li className={styles.list__item}>
        <a
          className={styles.link}
          href="https://code-cartoons.com/a-cartoon-intro-to-redux-3afb775501a6"
          target="_blank"
        >
          A cartoon intro to Redux
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://egghead.io/getting-started-with-redux" target="_blank">
          Getting Started with Redux by Dan Abramov
        </a>
      </li>
      <li className={styles.list__item}>
        <a
          className={styles.link}
          href="https://egghead.io/building-react-applications-with-idiomatic-redux"
          target="_blank"
        >
          Building React Applications with Idiomatic Redux by Dan Abramov
        </a>
      </li>
      <li className={styles.list__item}>
        <a className={styles.link} href="https://medium.com/devschacht/redux-step-by-step-e6c42a9b00cd" target="_blank">
          Redux: шаг за шагом
        </a>
      </li>
      <li className={styles.list__item}>
        <a
          className={styles.link}
          href="https://blog.bitsrc.io/using-redux-actions-why-and-how-fd5834f13e31"
          target="_blank"
        >
          Using Redux-Actions — Why and How?
        </a>
      </li>
      <li className={styles.list__item}>
        <a
          className={styles.link}
          href="https://trello-attachments.s3.amazonaws.com/59f1a4faa946cdc5b223e904/5b3942f050cf8a07452d6cf4/66ef29154a03d02375d1ffebf6dcb292/react-redux-workflow-graphical-cheat-sheet_v110.png"
          target="_blank"
        >
          React-Redux workflow - graphical cheat sheet
        </a>
      </li>
    </ul>
  </section>
))
